import { enterprises } from "./Enterprise.slice";

export const enterpriseActions = { ...enterprises.actions };
